
































































































import { Component, Vue } from 'vue-property-decorator';
import CountryFlag from '@dzangolab/vue-country-flag-icon';
import { INarrative, IScenario } from '../models';
import EditComponentCard from './edit-component-card.vue';
import ImportExportCard from './import-export-card.vue';
import DeleteCard from './delete-card.vue';
import { sortBy } from 'lodash';

@Component({
  components: { CountryFlag, EditComponentCard, ImportExportCard, DeleteCard },
})
export default class NavigationDrawer extends Vue {
  private languages: string[] = ['gb', 'nl'];
  private activeLanguage = '';
  private themes: string[] = ['light', 'dark'];
  private scenarios: Partial<IScenario>[] = [];
  private activeTheme = '';
  private activeScenario: Partial<IScenario> = {};
  private activeNarrative: INarrative = {} as INarrative;
  private menu = false;
  private importMenu = false;
  private narMenu = false;
  private drawer = false;

  private get sortedNarratives() {
    return this.activeScenario && this.activeScenario.narratives ? sortBy(this.activeScenario.narratives, 'name') : [];
  }

  private drawerChanged(d: boolean) {
    if (d === false) this.closeDrawer();
  }

  private async languageChanged() {
    this.$store.actions.changeLanguage(this.activeLanguage);
  }

  private async themeChanged() {
    this.$store.actions.changeTheme(this.activeTheme);
  }

  private async narrativeSelected() {
    this.$store.actions.changeNarrative(this.activeNarrative);
  }

  private async closeMenu() {
    this.menu = false;
  }

  private async closeImportMenu() {
    this.importMenu = false;
  }

  private async closeNarMenu() {
    this.narMenu = false;
  }

  private activeScenarioName() {
    this.activeScenario.name ? this.activeScenario.name : '-';
  }

  private closeDrawer() {
    this.$store.actions.toggleDrawer(false);
  }

  async mounted(): Promise<void> {
    console.log(`navigation mounted`);
    this.$store.states.map(a => {
      this.activeLanguage = a.app.language;
      this.activeTheme = a.app.theme;
      this.scenarios = a.scenarios.list || [];
      this.activeScenario = a.scenarios.current || {};
      this.activeNarrative = a.app.narrative || ({} as INarrative);
    });
    this.$store.states.map(a => {
      this.drawer = a.app.drawer;
    });
  }
}
